import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle } from 'recompose'
import { push } from 'react-router-redux'

import * as actions from 'modules/org/actions'
import * as profileActions from 'modules/profile/actions'
import * as selectors from 'modules/org/selectors'
import { page, track } from 'utils/trackingUtils'

import { api } from 'modules/org/api'

import ProfileColorStep from './component'

const mapStateToProps = state => ({
  color: selectors.getColor(state),
  profile: state.profile
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setColor: actions.setColor,
    updateEmbed: actions.updateEmbed,
    push,
    updateProfile: profileActions.updateProfile
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      page('Onboarding Profile Color Setup', {
        context: 'sales-onboarding',
      })
    }
  }),
  withHandlers({
    onColorClick: props => color => () => {
      props.actions.setColor(color.replace('#', ''))
    },
    onContinueClick: props => () => {
      track('Onboarding Profile Color Setup Completed', {
        context: 'sales-onboarding',
        skipped: false
      })

      api.updateEmbedPromise([{
        operation: 'set',
        value: props.color,
        property: 'theme.backgroundColor',
      }, {
        operation: 'set',
        value: props.color,
        property: 'theme.activeColor',
      }]).then(() => {
        props.actions.updateProfile([{
          operation: 'set',
          value: props.profile.coverPhotoUrl,
          property: 'coverPhotoUrl',
        }, {
          operation: 'set',
          value: 'WIDE',
          property: 'layout',
        }])
      })
      props.actions.push('/setup/profile/details')
    },

    onSkipClick: props => () => {
      track('Onboarding Profile Color Setup Completed', {
        context: 'sales-onboarding',
        skipped: true
      })
      props.actions.push('/setup/profile/details')
    },
  }),
)(ProfileColorStep)



// WEBPACK FOOTER //
// ./src/layouts/ProfileColorStep/index.js